import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArmchair: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArmchair"><Path d="M5 10V3H19V10H16V13H8V10H5Z" fill="currentColor"/><Path d="M3 12V19H5V21H7V19H17V21H19V19H21V11.5H18V15H6V12H3Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArmchair;
